import React from 'react';

import { PrimaryButton } from '@longline/aqua-ui/controls/PrimaryButton';

interface IPaneEditButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const PaneEditButton = (props: IPaneEditButtonProps) => {
  return (
    <PrimaryButton disabled={props.disabled} onClick={props.onClick}>EDIT</PrimaryButton>
  )
}

export { PaneEditButton }
